







































































import {Watch, Component, Emit, Ref, Vue} from 'vue-property-decorator';
import {namespace, State} from 'vuex-class';
import {MAFUser, UserTransaction} from '@/store/User/types';
import BButton from 'buefy/src/components/button/Button.vue';
import BField from 'buefy/src/components/field/Field.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import UploadMessageModal from '@/components/common/UploadMessageModal.vue';
import BModal from 'buefy/src/components/modal/Modal.vue';
import Filter from 'bad-words';
import luxon from '@/plugins/luxon';
import {DateTime} from 'luxon';
import * as _ from 'lodash';
import {message, MessagePrompt} from '@/store/Friends/types';

import VEmojiPicker from 'v-emoji-picker';
import packData from 'v-emoji-picker/data/emojis.json';

  /* tslint:disable:no-console */
  /* tslint:disable:max-line-length */
  /* tslint:disable:no-empty */

const friendNamespace = namespace('friendState');
const userNamespace = namespace('userState');
const pattern = new RegExp('\\(([^)]+)\\)[^)]*');

@Component({
    components: {
      BButton,
      BField,
      BInput,
      BIcon,
      UploadMessageModal,
      BModal,
      VEmojiPicker,
    },
  })

  export default class ChatBox extends Vue {

    get chatPrompt(): MessagePrompt[] {
      if (this.compMessages.length &&
        this.compMessages[this.compMessages.length - 1].prompt.message !== '' &&
        this.compMessages[this.compMessages.length - 1].from !== this.self.uid) {

        return this.compMessages[this.compMessages.length - 1].prompt.responses;
      }
      if (this.friend && this.friend.comparison) {
        return this.getChatPrompt(this.friend.comparison.firstMatchedInterestType);
      }
      return this.getChatPrompt('general');
    }

    get hasAudio() {
      const hasAudio = _.find(this.transactions, (t: UserTransaction) => {
        return t.purchase.what === 'audio';
      });
      return !!hasAudio;
    }

    get hasVideo() {
      const hasVideo = _.find(this.transactions, (t: UserTransaction) => {
        return t.purchase.what === 'video';
      });
      return !!hasVideo;
    }

    get hasMessage() {
        return this.messageToSend.trim().length <= 0;
    }

    get getSelfGender() {
      if (this.self.gender === 'male') {
        return 'male';
      } else if (this.self.gender === 'female') {
          return 'female';
      } else {
        return '';
      }
    }

    get compMessages(): message[] {
      if (this.friend) {
        let ret = this.getFriendMessages(this.friend.uid);
        if (this.sentMessage) {
          this.shouldScrollToBottom = true;
        }
        ret = _.orderBy(ret, ['sent'], ['asc']);
        return ret;
      }
      return [];
    }

    get getFriendGender() {
      if (this.friend && this.friend.gender === 'male') {
        return 'male';
      } else if (this.friend && this.friend.gender === 'female') {
          return 'female';
      } else {
        return '';
      }
    }
    get updateAvatar(): string | any {
        if (this.friend && this.friend.avataarUrl !== '') {
            return this.friend.getAvataarUrl(this.BASE_URL, true);
        }
        if (this.friend && this.friend.imageURL !== '') {
            return this.friend.imageURL;
        }
    }
    @userNamespace.State('self') public readonly self!: MAFUser;
    @friendNamespace.State('currentlyChattingWith') public readonly friend!: MAFUser;
    @friendNamespace.Mutation('setCurrentlyChattingWith') public setCurrentlyChattingWith!: any;
    @friendNamespace.Action('createMessage') public createMessage!: any;
    @friendNamespace.Getter('getChatPrompt') public getChatPrompt!: any;
    @friendNamespace.Getter('getFriendMessages') public getFriendMessages!: any;
    @friendNamespace.Action('getFriendReference') public getFriendReference!: any;
    @friendNamespace.Action('getFriendTransactions') public getFriendTransactions!: any;
    @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;
    @userNamespace.State('transactions') public readonly transactions!: UserTransaction[];
    @Ref('chatBody') public chatBody!: HTMLDivElement;

    public BASE_URL: string;
    public messageToSend: string;
    public shouldScrollToBottom: boolean;
    public sentMessage: boolean;
    public showUploadModal: boolean = false;
    public isImageModalActive: boolean = false;
    public activePic: string = '';
    public pack: any = packData;
    public showEmoji: boolean = false;
    public selectedPrompt: MessagePrompt | undefined;
    public emojiActive: boolean = false;
    public emojiActiveMobile: boolean = false;
    public openedAudio: boolean = false;
    public openedVideo: boolean = false;
    public filter: any;

    constructor() {
      super();
      this.messageToSend = '';
      this.sentMessage = false;
      this.shouldScrollToBottom = true;
      this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    }

    public async setSelectedPrompt(prompt: MessagePrompt, mes: string) {
      this.selectedPrompt = prompt;
      this.messageToSend = mes;
      await this.send(null);
    }

    public selectEmoji(emoji: any) {
      this.messageToSend += emoji.emoji;
    }

    public triggerUpMod() {
      this.showUploadModal = true;
    }

    public triggerEmoji() {
      if (window.innerWidth > 1023) {
        this.emojiActiveMobile = false;
        this.emojiActive = !this.emojiActive;
      } else {
        this.emojiActive = false;
        this.emojiActiveMobile = !this.emojiActiveMobile;
      }
    }

    @Emit('showUser')
    public showUser( userId: string ) {
      return userId;
    }

    @Emit('showVideo')
    public triggerVideo() {
      return this.friend;
    }

    @Emit('showAudio')
    public triggerAudio() {
      return this.friend;
    }

    @Emit('showMeetup')
    public showMeetup() {
    }

    @Emit('showBlockedUser')
    public showBlockUser() {
      return this.friend;
    }

    @Emit('showReportUser')
    public showReportUser() {
      return this.friend;
    }

    public substiteParams(str: string): string {
      let ret = '';
      const array = str.split(' ');
      array.forEach((word) => {
        if (pattern.test(word)) {
          let check = word.slice(1, word.length - 1);
          let hadPunctuation = false;
          if (check.substring(check.length - 1) === ')') {
            check = check.slice(0, check.length - 1);
            hadPunctuation = true;
          }
          if (check === 'name') {
            check = this.self.name ? this.self.name : '';
            if (hadPunctuation) {
              check += '.';
            }
          }

          if (check === 'friendname') {
            check = this.friend.name ? this.friend.name : '';
            if (hadPunctuation) {
              check += '!';
            }
          }

          ret += check + ' ';
        } else {
          ret += word + ' ';
        }
      });
      return ret.trim();
    }

    public showImage(imgRef: string) {
      this.activePic = imgRef;
      this.isImageModalActive = true;
    }

    public updated() {
      if (this.shouldScrollToBottom) {
        this.scrollToBottom();
        this.shouldScrollToBottom = false;
      }
    }

    public mounted() {
      if (this.shouldScrollToBottom) {
        this.scrollToBottom();
        this.shouldScrollToBottom = false;
      }

      // init swear filter
      this.filter = new Filter();
      this.addSwearWords();
    }

    public scrollToBottom() {
      if (this.chatBody) {
        this.chatBody.scrollTop = this.chatBody.scrollHeight + 50;
      }
    }

    /* tslint:disable:max-line-length */
    public async send(e: any) {
      if (e) {
        e.preventDefault();
      }
      this.sentMessage = true;
      const sent = DateTime.local().toJSDate();
      const ref = await this.$firestore.collection('users').doc(this.friend.uid);

      // filter swear words
      this.messageToSend = this.filter.clean(this.messageToSend);

      const mes: message =
        new message(this.friend.uid, this.self.uid, sent, this.messageToSend, ref, false, null, null);
      if (this.selectedPrompt) {
        mes.prompt = this.selectedPrompt;
      }

      try {
        await this.createMessage(mes.toPlainObj());
        this.sendEmailNotification({to: this.friend.email, mess: `You have a message from ${this.self.name}. Check message now at <a href="http://www.makingauthenticfriendships.com">http://makingauthenticfriendships.com</a>`});

        if (this.friend.phoneNumber && this.friend.cellProvider && this.friend.phoneNumber.replace(/^[2-9]\d{2}-\d{3}-\d{4}$/g, '') === '') {
          let carrier = '';

          switch (this.friend.cellProvider) {
            case 'AT&T':
              carrier = '@txt.att.net';
              break;
            case 'Verizon':
              carrier = '@vtext.com';
              break;
            case 'Sprint':
              carrier = '@messaging.sprintpcs.com';
              break;
            case 'TMobile':
              carrier = '@tmomail.net';
              break;
          }

          const phone = this.friend.phoneNumber.replace(/\-/g, '');
          this.sendEmailNotification({to: `${phone}${carrier}`, mess: `You have a message! <a href="http://www.makingauthenticfriendships.com">http://makingauthenticfriendships.com</a>`});
        }

      } catch (error) {
        console.error(error);
      }

      this.messageToSend = '';
    }

    public close() {
      this.setCurrentlyChattingWith(null);
    }

    public addSwearWords() {
      this.filter.addWords(
        'damnit',
        'damint',
        'dammit',
        'bullshit',
        'freak',
        'shoot',
        'heck',
        'dumbass',
        'dumass',
      );
    }
}
